import { rem } from 'polished'
import React from 'react'
import styled from 'styled-components'

import PlaceholderBox from './PlaceholderBox'

import LoadingBox from 'components/Common/Loading/LoadingBox'
import TextLoadingBox from 'components/Luxkit/Typography/TextLoadingBox'
import { mediaQueryUp } from 'components/utils/breakpoint'
import Group from 'components/utils/Group'

const CardContainer = styled.div`
  display: flex;
  justify-content: space-around;
`

const Container = styled.div`
  position: relative;
  width: 100%;
  background-color: white;
  max-width: ${rem(300)};

  ${mediaQueryUp.largeDesktop} {
    max-width: ${rem(700)};
  }
`

const ImageContainer = styled.div`
  width: 100%;

  > * {
    height: 100%;
    aspect-ratio: 16/9;
  }

  ${mediaQueryUp.largeDesktop} {
    width: 33%;
  }
`
const ContentWrapper = styled.div`
  padding: ${rem(16)};
  width: 100%;
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: start;
  gap: ${rem(8)};

  ${mediaQueryUp.largeDesktop} {
    padding: ${rem(24)};
  }
`

const MainGroup = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;

  ${mediaQueryUp.largeDesktop} {
    flex-direction: row-reverse;
    justify-content: space-between;
  }
`

function ExploreCardSkeleton() {
  return (
    <CardContainer>
      <Container>
        <MainGroup>
          <ImageContainer>
            <PlaceholderBox style={{ width: '100%' }} />
          </ImageContainer>
          <ContentWrapper>
            <Group direction="vertical" gap={8} style={{ width: '100%' }}>
              <TextLoadingBox width="50%" typography="body-small" />
              <TextLoadingBox width="70%" typography="heading6" />
              <TextLoadingBox width="60%" typography="body-small" />
              <TextLoadingBox width={70} typography="heading3" />
            </Group>
            <LoadingBox />
          </ContentWrapper>
        </MainGroup>
      </Container>
    </CardContainer>
  )
}

export default ExploreCardSkeleton
